// extracted by mini-css-extract-plugin
export default {"brandSlider":"BrandSlider_brandSlider__gzPuk","sliderTrack":"BrandSlider_sliderTrack__uEkmx","scroll":"BrandSlider_scroll__IMCjp","slide":"BrandSlider_slide__6vNiD"};